import {FAQItem} from 'attendee/Help/FAQ'
import React, {ReactElement, useMemo} from 'react'
import {useI18n} from 'i18n/I18nContext'
import {getOrgFaqEntry} from './orgFaqData'
import {ORG_FAQ_ORDER, type OrgFaqKey} from './orgFaqKeys'

export {
  ORG_FAQ_ORDER as FAQ_ORDER,
  type OrgFaqKey as FAQKey,
} from './orgFaqKeys'

export {OrgFaqHelp} from './OrgFaqHelp'

type FAQItemData = {
  question: string
  answer: ReactElement
}

export function useOrgFaqItems(): Record<OrgFaqKey, FAQItemData> {
  const {locale} = useI18n()
  return useMemo(() => {
    const out = {} as Record<OrgFaqKey, FAQItemData>
    for (const key of ORG_FAQ_ORDER) {
      const {q, a} = getOrgFaqEntry(locale, key)
      out[key] = {
        question: q,
        answer: (
          <div style={{whiteSpace: 'pre-line'}} className="org-faq-answer">
            {a}
          </div>
        ),
      }
    }
    return out
  }, [locale])
}

export function FAQ(): JSX.Element {
  const items = useOrgFaqItems()
  return (
    <div className="accordion" id="accordionFAQ">
      {ORG_FAQ_ORDER.map((key, index) => {
        const item = items[key]
        return (
          <FAQItem
            key={key}
            open={index === 0}
            question={item.question}
            answer={item.answer}
          />
        )
      })}
    </div>
  )
}
